export const CLASS_GALLERY = "entribe_gallery_v100_2023";

export const CONTENT_TYPE = {
  VERIFIED: "verified",
  SELECT: "select",
  CONTENT: "content",
};

export const MEDIA_TYPE = {
  VIDEO: "video",
  IMAGE: "image",
};

export const PAGINATION = {
  pageSize: 200,
  pageCurrent: 1,
  pageSizeOptions: [15, 30, 50, 100],
};

export const SCREEN_MODE = {
  SLIDER: {
    S: "slider_1",
    M: "slider_3",
    L: "slider_5",
  },
  GRID: {
    S: "grid_1",
    M: "grid_4",
    L: "grid_6",
    XL: "grid_8",
  },
  MOSAIC: {
    S: "mosaic_1",
    M: "mosaic_3",
    L: "mosaic_5",
  },
};

export const SOCIAL_PROFILE = {
  INSTAGRAM: "https://www.instagram.com/",
  TWTTER: "https://twitter.com/",
  TIKTOK: "https://www.tiktok.com/@",
  YOUTUBE: "https://www.youtube.com/channel/",
  FACEBOOK: "https://www.facebook.com/",
};

export const SOCIAL = {
  INSTAGRAM: "Instagram",
  TWITTER: "Twitter",
  YOUTUBE: "YouTube",
  TIKTOK: "TikTok",
};

export const PENDO_TRACKING_TYPE = {
  LOADED: {
    label: "LOADED",
    description: "Gallery Visited",
  },
  UPLOADER_LINK_CLICKED: {
    label: "UPLOADER_LINK_CLICKED",
    description: "Gallery Uploader Link Clicked",
  },
  IMAGE_CLICKED: {
    label: "IMAGE_CLICKED",
    description: "Gallery Image Clicked",
  },
  SOCIAL_USERNAME_CLICKED: {
    label: "SOCIAL_USERNAME_CLICKED",
    description: "Content Sociallink Clicked",
  },
  HYPERLINK_CAPTION_CLICKED: {
    label: "HYPERLINK_CAPTION_CLICKED",
    description: "Content Hyperlink Clicked",
  },
  CONTENT_VISITED: {
    label: "CONTENT_VISITED",
    description: "Content Visited",
  },
  ALL_GALLERY_VISITED: {
    label: "ALL_GALLERY_VISITED",
    description: "All Gallery Visited",
  },
  ALL_CONTENT_VISITED: {
    label: "ALL_CONTENT_VISITED",
    description: "All Gallery Content Visited",
  },
  ALL_HYPERLINK_CLICKED: {
    label: "ALL_HYPERLINK_CLICKED",
    description: "All Gallery Content Hyperlink Clicked",
  },
  GALLERY_HYPERLINK_CLICKED: {
    label: "GALLERY_HYPERLINK_CLICKED",
    description: "Gallery Hyperlink Clicked",
  },
  GALLERY_SOCIALLINK_CLICKED: {
    label: "GALLERY_SOCIALLINK_CLICKED",
    description: "Gallery Sociallink Clicked",
  },
};

export const DEFAULT_ERROR = "Server error, please try again later";

export const NONE = 0;
export const IN_PROGRESS = 1;
export const SUCCEEDED = 2;
export const FAILED = 3;
export const COMPLETED = 4;

export const FILE_TYPE = {
  PNG: ".png",
  JPG: ".jpg",
  JPEG: "jpeg",
  GIF: ".gif",
};

export const TIME_OUT = {
  T_100: 100,
  T_150: 150,
  T_200: 200,
  T_250: 250,
  T_400: 400,
  T_450: 450,
  T_1000: 1000,
};

export const SUBTITLE_EXTENSION = ".vtt";

export const LAZY_LOAD = {
  ON_DEMAND: "ondemand",
  PROGRESSIVELY: "progressively",
};

export const DEFAULT_WIDGET_ID = 9999;

export const MAX_RECORDS = 9999;

export const PATTERNS = {
  BASE64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
};

export const PREFIX_CLS = "lib-entribe";

export const TYPE_CUSTOM_FIELD = {
  email: "email",
  instagram: "instagram",
  twitter: "twitter",
  tiktok: "tiktok",
  phone: "phone",
  dropdown: "dropdown",
  shortAnswer: "shortAnswer",
  paragraph: "paragraph",
  mailAddress: "mailAddress",
};

export const BRAND_NAME = {
  INKEDIBLES: "Inkedibles",
};

export const PLACEHOLDER_IMAGE_IN_BASE64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==";

export const CONTENT_FLAGS = {
  EXPLICIT_CONTENT: "explicit content",
};

export const FONT_FAMILY = {
  IBM_PLEX_SANS: "IBM Plex Sans",
};

export const MINE_TYPE = {
  MP4: "video/mp4",
};

export const HTML_TAG_ATTRIBUTE = {
  ARIA_LABEL: "aria-label",
  CROSS_ORIGIN: "crossOrigin",
  ALT: "alt",
};

export const UPLOADSOURCE = {
  SOCIAL_SEARCH: "social-search",
  SOCIAL_UPLOAD: "social-upload",
  DIRECT_UPLOAD: "direct-upload",
  MANUAL_IMPORT: "manual-import",
  SCRIPT_IMPORT: "script-import",
  SOCIAL_SEARCH_UPCASE: "SOCIAL_SEARCH",
};

export const GALLERY_SELECTORS = {
  ENTRIBE_GALLERY_VIDEO_TRACK: "entribe_gallery_video_track",
};
